<template>
  <FieldBox :title="$t('trade.add-order')">
    <SelectBox v-model="attachOrderType" :options="orderTypes" />
  </FieldBox>
</template>
<script>
import FieldBox from '../FieldBox'
import SelectBox from 'com/SelectBox'
import { mapGetters } from 'vuex'
import { MARKET_TYPE, SEC_TYPE } from 'const/stock'
export default {
  name: 'AttachTypeField',
  components: {
    FieldBox,
    SelectBox
  },
  props: { minTicks: Array },
  computed: {
    ...mapGetters(['tradeRequest']),
    order() {
      return this.tradeRequest.order
    },
    stock() {
      return this.tradeRequest.stock
    },
    isUSSTK() {
      return (
        this.stock.market === MARKET_TYPE.US &&
        this.stock.secType === SEC_TYPE.STK
      )
    },
    minTick() {
      const price = parseFloat(this.order.limitPrice)
      for (let i = 0; i < this.minTicks.length; i++) {
        const tick = this.minTicks[i]
        if (price >= tick.begin && price < tick.end) {
          return tick.tickSize || tick.minTick
        }
      }
      return 0
    },
    orderTypes() {
      return [
        { text: this.$t('trade.add-no'), val: 'NO' },
        { text: this.$t('trade.stop-profit-trade'), val: 'PROFIT' },
        { text: this.$t('trade.stop-loss-trade'), val: 'LOSS' },
        { text: this.$t('trade.brackets-trade'), val: 'BRACKETS' }
      ]
    },
    attachOrderType: {
      get() {
        return this.order.attachOrderType
      },
      set(attachOrderType) {
        return this.$store.dispatch('updateTradeOrder', { attachOrderType })
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '~uikit';
.tt-select-box {
  width: 100%;
}
</style>
